import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-chouqu",
  "use": "icon-chouqu-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-chouqu\"><defs><style type=\"text/css\"></style></defs><path d=\"M96 160A32 32 0 0 1 128 128h768a32 32 0 0 1 32 32V448a32 32 0 0 1-31.936 32h-768a32 32 0 0 1-32-32L96 160zM256 336h192v-64H256v64zM96.064 576a32 32 0 0 1 32-32h768a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32h-768a32 32 0 0 1-32-32V576zM256 752h192v-64H256v64z\" p-id=\"4562\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol